export const CELL_WIDTH = 100;
export const CELL_HEIGHT = 20;
export const CELL_TEXT_MARGIN_LEFT = 2;
export const CELL_TEXT_MARGIN_TOP = -1;
export const GRID_SIZE = 150;
export const ZOOM_ANIMATION_TIME_MS = 250;
